import React, { InputHTMLAttributes, LegacyRef } from 'react';
import { IMaskMixin } from 'react-imask';

type IMaskInputProps = InputHTMLAttributes<HTMLInputElement> & {
  inputRef?: LegacyRef<HTMLInputElement>;
};

const IMaskInput = IMaskMixin(({ inputRef, ...props }: IMaskInputProps) => {
  return <input ref={inputRef} {...props} />;
});

export type MaskedInputProps = IMaskInputProps & {
  mask: any;
  unmask: true | false | 'typed';
  onAccept?: (...args: any) => void;
  dataCy?: string;
};

export default function MaskedInput(props: MaskedInputProps) {
  return <IMaskInput {...props} data-cy={props.dataCy} />;
}
